// Slideshow viewport autoplay control
// This script uses Intersection Observer to start/pause slideshow autoplay when visible

document.addEventListener('DOMContentLoaded', function() {
  var slideshows = document.querySelectorAll('[data-autoplay-viewport-only="true"]');
  if (!('IntersectionObserver' in window)) return;

  slideshows.forEach(function(slideshow) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          slideshow.dispatchEvent(new Event('slideshow:start'));
        } else {
          slideshow.dispatchEvent(new Event('slideshow:pause'));
        }
      });
    }, { threshold: 0.1 });
    observer.observe(slideshow);

    // Example: Connect to your slideshow's play/pause logic
    // Replace these with your actual slideshow play/pause methods if needed
    slideshow.addEventListener('slideshow:start', function() {
      if (typeof window.themeSlideshowPlay === 'function') {
        window.themeSlideshowPlay(slideshow);
      }
    });
    slideshow.addEventListener('slideshow:pause', function() {
      if (typeof window.themeSlideshowPause === 'function') {
        window.themeSlideshowPause(slideshow);
      }
    });
  });
});
